"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableToolbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _IconBtnTooltip = _interopRequireDefault(require("../../../IconBtnTooltip"));

var _Search = _interopRequireDefault(require("../../../Search"));

var _Filter = _interopRequireDefault(require("../../../Filter"));

var _helper = require("../../helper");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles() {
  return {
    searchMenuItem: {
      paddingTop: '2px',
      paddingBottom: '2px'
    }
  };
};

var TableToolbar = /*#__PURE__*/function (_Component) {
  _inherits(TableToolbar, _Component);

  var _super = _createSuper(TableToolbar);

  function TableToolbar() {
    var _this;

    _classCallCheck(this, TableToolbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      searchTerm: '',
      showSearchSuggestions: false,
      selectedSearchMenuIndex: -1,
      selectedFilters: {},
      viewColumnsAnchor: null
    });

    _defineProperty(_assertThisInitialized(_this), "searchBarCompose", function () {
      var _this$props = _this.props,
          tableActions = _this$props.tableActions,
          _this$props$tableData = _this$props.tableData,
          columns = _this$props$tableData.columns,
          rowData = _this$props$tableData.rowData,
          classes = _this$props.classes,
          searchOpen = _this$props.searchOpen,
          searchPlaceholder = _this$props.searchPlaceholder;
      var _this$state = _this.state,
          searchTerm = _this$state.searchTerm,
          showSearchSuggestions = _this$state.showSearchSuggestions,
          selectedSearchMenuIndex = _this$state.selectedSearchMenuIndex;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "tableSearchAction",
        className: "TableToolbar_search"
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
        disabled: rowData.length === 0,
        direction: "right",
        onChange: function onChange(searchTerm) {
          return _this.setState({
            searchTerm: searchTerm
          }, (0, _lodash.debounce)(_this.onSearchFilter, 300));
        },
        onSearchFocus: _this.props.onSearchFocus,
        value: searchTerm,
        open: searchOpen,
        placeholder: searchPlaceholder
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_searchMenu".concat(showSearchSuggestions ? ' show' : ''),
        id: "TableToolbar_searchMenu"
      }, tableActions.getVisibleColumns(columns).map(function (column, index) {
        return column.title && (column.canSearch === undefined || column.canSearch) ? /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
          selected: selectedSearchMenuIndex === index,
          key: column.key,
          classes: {
            root: classes.searchMenuItem
          },
          onClick: function onClick() {
            return _this.onSearchSuggestionClick(index);
          }
        }, "Find \"".concat(searchTerm, "\" in ").concat(column.title)) : null;
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_searchOverlay".concat(showSearchSuggestions ? 'Show' : 'Hide'),
        onClick: _this.searchMenuHide
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "viewColumnsCompose", function () {
      var _this$props$tableData2 = _this.props.tableData,
          columns = _this$props$tableData2.columns,
          rowData = _this$props$tableData2.rowData;
      var viewColumnsAnchor = _this.state.viewColumnsAnchor;
      var oneShownColumn = columns.filter(function (column) {
        return column.show;
      }).length === 1;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        buttonProps: {
          color: 'primary',
          style: {
            marginRight: '5px'
          },
          disabled: rowData.length === 0
        },
        onClick: function onClick(event) {
          return _this.setState({
            viewColumnsAnchor: event.currentTarget
          });
        },
        icon: "view_column",
        title: "View Columns"
      }), /*#__PURE__*/_react["default"].createElement(_material.Popover, {
        open: Boolean(viewColumnsAnchor),
        anchorEl: viewColumnsAnchor,
        onClose: function onClose() {
          return _this.setState({
            viewColumnsAnchor: null
          });
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        PaperProps: {
          style: {
            padding: '10px'
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_showColumnsTitle"
      }, "SHOW COLUMNS"), columns.map(function (column, index) {
        return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
          disabled: oneShownColumn && column.show,
          key: column.key,
          onClick: function onClick() {
            return _this.handleShowColumnClick(index);
          },
          style: {
            padding: '0 10px'
          },
          value: column.title
        }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
          checked: column.show
        }), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
          primary: column.title
        }));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "handleShowColumnClick", function (columnIndex) {
      var columns = (0, _lodash.cloneDeep)(_this.props.tableData.columns);
      columns[columnIndex].show = !columns[columnIndex].show;

      _this.props.tableActions.updateTableState({
        columns: columns
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearSelectedFilters", function (selectedFilters) {
      var _this$props2 = _this.props,
          tableActions = _this$props2.tableActions,
          _this$props2$tableDat = _this$props2.tableData,
          columns = _this$props2$tableDat.columns,
          idKey = _this$props2$tableDat.idKey,
          rowData = _this$props2$tableDat.rowData,
          tableSettings = _this$props2$tableDat.tableSettings;
      var searchTerm = _this.state.searchTerm;
      var filteredRowData = (0, _helper.dataFilter)(rowData, tableActions.getVisibleColumns(columns), idKey, searchTerm);

      _this.setState({
        selectedFilters: selectedFilters
      });

      _this.props.tableActions.updateTableState({
        rowData: filteredRowData,
        tableSettings: _objectSpread(_objectSpread({}, tableSettings), {}, {
          selectedFilters: selectedFilters
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dataFilter", function (selectedFilters) {
      var _this$props3 = _this.props,
          tableActions = _this$props3.tableActions,
          _this$props3$tableDat = _this$props3.tableData,
          columns = _this$props3$tableDat.columns,
          idKey = _this$props3$tableDat.idKey,
          rowData = _this$props3$tableDat.rowData,
          tableSettings = _this$props3$tableDat.tableSettings;
      var searchTerm = _this.state.searchTerm;
      var pageIndex = tableSettings.pageIndex,
          rowsPerPage = tableSettings.rowsPerPage;
      var filteredRowData = (0, _helper.dataFilter)(rowData, tableActions.getVisibleColumns(columns), idKey, searchTerm); // filters rows based on selected filters now

      filteredRowData.forEach(function (row) {
        if (row.filtered) {
          // If anything in row becomes a filter status of false, the entire row should be filtered out of displayed data (filter: false)
          var isFiltered = !Object.entries(selectedFilters).some(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                filters = _ref2[1];

            return !filters.includes(row[key]) && filters.length > 0;
          });
          row.filtered = isFiltered;
        }
      });
      var filteredRowsLength = filteredRowData.filter(function (row) {
        return row.filtered;
      }).length;
      var isPageIndexToHigh = Math.floor((filteredRowsLength - 1) / rowsPerPage) <= pageIndex;

      var updatedTableSettings = _objectSpread(_objectSpread({}, tableSettings), {}, {
        pageIndex: isPageIndexToHigh ? 0 : pageIndex,
        searchTerm: searchTerm,
        selectedFilters: selectedFilters
      });

      var updatedState = {
        rowData: filteredRowData,
        tableSettings: updatedTableSettings
      };

      _this.props.tableActions.updateTableState(updatedState);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveFilter", function (filterKey, filterLabel) {
      var selectedFilters = (0, _lodash.cloneDeep)(_this.state.selectedFilters); // remove filter from selectedFilters

      selectedFilters[filterKey] = selectedFilters[filterKey].filter(function (selectedFilter) {
        return selectedFilter !== filterLabel;
      });

      _this.dataFilter(selectedFilters); // updates rowData based on new selectedFilters


      _this.setState({
        selectedFilters: selectedFilters
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterSelection", function (selectedFilters) {
      _this.dataFilter(selectedFilters); // updates rowData based on new selectedFilters


      _this.setState({
        selectedFilters: selectedFilters
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchFilter", function () {
      var _this$props4 = _this.props,
          canFilter = _this$props4.canFilter,
          _this$props4$tableAct = _this$props4.tableActions,
          getFormattedRowData = _this$props4$tableAct.getFormattedRowData,
          getVisibleColumns = _this$props4$tableAct.getVisibleColumns,
          _this$props4$tableDat = _this$props4.tableData,
          columns = _this$props4$tableDat.columns,
          idKey = _this$props4$tableDat.idKey,
          rowData = _this$props4$tableDat.rowData,
          tableSettings = _this$props4$tableDat.tableSettings;
      var _this$state2 = _this.state,
          searchTerm = _this$state2.searchTerm,
          selectedFilters = _this$state2.selectedFilters;
      var pageIndex = tableSettings.pageIndex,
          rowsPerPage = tableSettings.rowsPerPage,
          selectedRows = tableSettings.selectedRows;
      var visibleColumns = getVisibleColumns(columns);

      if (searchTerm.length > 0 && !searchTerm.includes(':')) {
        _this.searchMenuShow();
      } else {
        _this.searchMenuHide();
      }

      var filteredRowData = searchTerm ? (0, _helper.dataFilter)(rowData, visibleColumns, idKey, searchTerm) : getFormattedRowData(selectedRows, true); // after search results are filtered, apply filters with selected filters too, if enabled

      canFilter && filteredRowData.forEach(function (row) {
        if (row.filtered) {
          // If anything in row becomes a filter status of false, the entire row should be filtered out of displayed data (filter: false)
          var isFiltered = !Object.entries(tableSettings.selectedFilters).some(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                filters = _ref4[1];

            return !filters.includes(row[key]) && filters.length > 0;
          });
          row.filtered = isFiltered;
          row.selected = isFiltered ? row.selected : false; // if row is now filtered out (false), unselect row
        }
      });
      var filteredRowsLength = filteredRowData.filter(function (row) {
        return row.filtered;
      }).length;
      var isPageIndexToHigh = Math.floor((filteredRowsLength - 1) / rowsPerPage) <= pageIndex;

      var updatedTableSettings = _objectSpread(_objectSpread({}, tableSettings), {}, {
        pageIndex: isPageIndexToHigh ? 0 : pageIndex,
        searchTerm: searchTerm,
        selectedFilters: selectedFilters,
        // clear out any sorting while searching
        sortColumn: '',
        sortDirection: null
      });

      var updatedState = {
        rowData: filteredRowData,
        tableSettings: updatedTableSettings
      };

      _this.props.tableActions.updateTableState(updatedState);
    });

    _defineProperty(_assertThisInitialized(_this), "searchMenuShow", function () {
      _this.setState({
        showSearchSuggestions: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchMenuHide", function () {
      _this.setState({
        showSearchSuggestions: false,
        selectedSearchMenuIndex: -1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchSuggestionClick", function (index) {
      var column = _this.props.tableActions.getVisibleColumns(_this.props.tableData.columns)[index];

      var searchTerm = "".concat(column.title, ": ").concat(_this.state.searchTerm);

      _this.setState({
        searchTerm: searchTerm
      }, _this.onSearchFilter);
    });

    _defineProperty(_assertThisInitialized(_this), "bulkStatusChangeCompose", function () {
      var _this$props5 = _this.props,
          loading = _this$props5.loading,
          _this$props5$tableDat = _this$props5.tableData,
          rowData = _this$props5$tableDat.rowData,
          statusOptions = _this$props5$tableDat.statusOptions,
          selectedRows = _this$props5$tableDat.tableSettings.selectedRows;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_bulkOptions"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "bulkStatusCheckbox"
      }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        checked: rowData.length > 0 && rowData.length === selectedRows.length,
        onChange: function onChange(e, checked) {
          return _this.props.tableActions.selectAllRowsHandle(checked);
        },
        indeterminate: selectedRows.length > 0 && selectedRows.length < rowData.length,
        disabled: loading
      })), statusOptions.map(function (_ref5) {
        var display = _ref5.display,
            value = _ref5.value,
            onClick = _ref5.onClick,
            disabled = _ref5.disabled;
        return /*#__PURE__*/_react["default"].createElement(_material.Button, {
          key: value,
          color: "primary",
          onClick: onClick ? function () {
            return onClick(rowData, value);
          } : function () {
            return _this.bulkStatusChange(value);
          },
          disabled: selectedRows.length === 0 || loading || disabled
        }, display || value);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "bulkStatusChange", function (statusOption) {
      var updatedRowData = (0, _lodash.cloneDeep)(_this.props.tableData.rowData);
      updatedRowData.forEach(function (row) {
        if (row.selected) {
          row.statusOption = statusOption;
        }
      });

      _this.props.tableActions.updateTableState({
        rowData: updatedRowData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "bulkActionsCompose", function () {
      var _this$props6 = _this.props,
          loading = _this$props6.loading,
          _this$props6$tableDat = _this$props6.tableData,
          rowData = _this$props6$tableDat.rowData,
          bulkActions = _this$props6$tableDat.bulkActions,
          selectedRows = _this$props6$tableDat.tableSettings.selectedRows;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_bulkOptions"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "bulkStatusCheckbox"
      }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        checked: rowData.length > 0 && rowData.length === selectedRows.length,
        onChange: function onChange(e, checked) {
          return _this.props.tableActions.selectAllRowsHandle(checked);
        },
        indeterminate: selectedRows.length > 0 && selectedRows.length < rowData.length,
        disabled: loading
      })), bulkActions.map(function (_ref6) {
        var display = _ref6.display,
            _onClick = _ref6.onClick,
            disabled = _ref6.disabled,
            icon = _ref6.icon;
        var selectedRows = rowData.filter(function (row) {
          return row.selected;
        });
        return icon ?
        /*#__PURE__*/
        // use icon, if provided
        _react["default"].createElement(_IconBtnTooltip["default"], {
          key: display,
          buttonProps: {
            disabled: selectedRows.length === 0 || loading || disabled
          },
          onClick: function onClick() {
            return _onClick(selectedRows, display);
          },
          icon: icon,
          title: display
        }) : /*#__PURE__*/_react["default"].createElement(_material.Button, {
          key: display,
          color: "primary",
          onClick: function onClick() {
            return _onClick(selectedRows, display);
          },
          disabled: selectedRows.length === 0 || loading || disabled
        }, display);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "keyPressHandle", function (e) {
      var tableActions = _this.props.tableActions;
      var _this$state3 = _this.state,
          showSearchSuggestions = _this$state3.showSearchSuggestions,
          selectedSearchMenuIndex = _this$state3.selectedSearchMenuIndex;
      var visibleColumns = tableActions.getVisibleColumns(_this.props.tableData.columns);

      if (e.keyCode === 27) {
        // ESC Key
        _this.searchMenuHide();
      }

      if (showSearchSuggestions) {
        switch (e.keyCode) {
          case 9:
            {
              // Tab key
              _this.searchMenuHide();

              break;
            }

          case 13:
            {
              // Enter Key
              if (selectedSearchMenuIndex > -1) {
                _this.onSearchSuggestionClick(selectedSearchMenuIndex);
              } else {
                _this.searchMenuHide();
              }

              break;
            }

          case 40:
            {
              // Arrow Down Key
              if (selectedSearchMenuIndex < visibleColumns.length - 1) {
                _this.setState({
                  selectedSearchMenuIndex: selectedSearchMenuIndex + 1
                });
              }

              break;
            }

          case 38:
            {
              // Arrow Up Key
              if (selectedSearchMenuIndex > -1) {
                _this.setState({
                  selectedSearchMenuIndex: selectedSearchMenuIndex - 1
                });
              }

              break;
            }

          default:
            break;
        }
      }
    });

    return _this;
  }

  _createClass(TableToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props7 = this.props,
          bulkActions = _this$props7.bulkActions,
          bulkStatusChange = _this$props7.bulkStatusChange,
          updateTableState = _this$props7.tableActions.updateTableState,
          _this$props7$tableDat = _this$props7.tableData.tableSettings,
          searchTerm = _this$props7$tableDat.searchTerm,
          selectedFilters = _this$props7$tableDat.selectedFilters;
      (bulkActions || bulkStatusChange) && updateTableState({
        bulkActions: bulkActions,
        bulkStatusChange: bulkStatusChange
      }); // if initial searchTerm or selectedFilters is provided, set it and run onSearchFilter

      (searchTerm || !(0, _lodash.isEmpty)(selectedFilters)) && this.setState({
        searchTerm: searchTerm,
        selectedFilters: selectedFilters
      }, function () {
        _this2.onSearchFilter();

        _this2.searchMenuHide();
      });
      document.addEventListener('keyup', this.keyPressHandle);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var selectedFilters = this.props.tableData.tableSettings.selectedFilters;

      if (!(0, _lodash.isEmpty)(selectedFilters) && !(0, _lodash.isEqual)(prevProps.tableData.tableSettings.selectedFilters, selectedFilters)) {
        this.setState({
          selectedFilters: selectedFilters
        }, function () {
          return _this3.onSearchFilter();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keyup', this.keyPressHandle);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props8 = this.props,
          _this$props8$tableDat = _this$props8.tableData,
          bulkActions = _this$props8$tableDat.bulkActions,
          bulkStatusChange = _this$props8$tableDat.bulkStatusChange,
          columns = _this$props8$tableDat.columns,
          rowData = _this$props8$tableDat.rowData,
          selectEnabled = _this$props8$tableDat.selectEnabled,
          statusOptions = _this$props8$tableDat.statusOptions,
          title = _this$props8$tableDat.title,
          tableSettings = _this$props8$tableDat.tableSettings,
          canFilter = _this$props8.canFilter,
          canHideColumns = _this$props8.canHideColumns,
          canSearch = _this$props8.canSearch,
          customToolbarSection = _this$props8.customToolbarSection,
          keepSelectedFilters = _this$props8.keepSelectedFilters;
      var selectedFilters = this.state.selectedFilters;
      var leftToolbarSection = null;
      if (customToolbarSection) leftToolbarSection = customToolbarSection();else if (bulkStatusChange && selectEnabled && statusOptions.length > 0) leftToolbarSection = this.bulkStatusChangeCompose();else if (selectEnabled && bulkActions.length > 0) leftToolbarSection = this.bulkActionsCompose();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_leftActions"
      }, leftToolbarSection), title && /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_title"
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_rightActions"
      }, canSearch && this.searchBarCompose(), canFilter && /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
        columns: columns,
        data: rowData,
        disabled: rowData.length === 0,
        onFilterChange: this.onFilterSelection,
        onFilterReset: this.clearSelectedFilters,
        selectedFilters: _objectSpread(_objectSpread({}, selectedFilters), tableSettings.selectedFilters) // load in existing selectedFilters, if they exist
        ,
        keepSelectedFilters: keepSelectedFilters
      }), canHideColumns && this.viewColumnsCompose())), canFilter && /*#__PURE__*/_react["default"].createElement("div", {
        className: "TableToolbar_filterChips"
      }, Object.entries(selectedFilters).map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            filterList = _ref8[1];

        return filterList.map(function (filterLabel) {
          return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
            color: "primary",
            key: filterLabel,
            label: filterLabel,
            onDelete: function onDelete() {
              return _this4.onRemoveFilter(key, filterLabel);
            },
            style: {
              margin: '0 5px 5px 0'
            }
          });
        });
      })));
    }
  }]);

  return TableToolbar;
}(_react.Component);

exports.TableToolbar = TableToolbar;

_defineProperty(TableToolbar, "propTypes", {
  // props given on TableToolbar
  // Custom component that will go into the left portion of the Tooltip bar. All props and logic will be in parent component
  customToolbarSection: _propTypes["default"].func,

  /** Boolean to show actions that will affect all selected rows */
  bulkActions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    display: _propTypes["default"].string.isRequired,
    icon: _propTypes["default"].string,
    // if icon provided, use IconBtnTooltip, otherwise a normal button will be used
    onClick: _propTypes["default"].func.isRequired,
    // Callback that provides the selectedRows, also provides display as a 2nd argument
    disabled: _propTypes["default"].bool
  })),

  /** Boolean to show status option selection buttons and checkbox to make bulk status changes */
  bulkStatusChange: _propTypes["default"].bool,

  /** Class names injected by the withStyles HOC provided by Material UI */
  classes: _propTypes["default"].object.isRequired,
  // Boolean used to turn off filter menu, default is true.
  canFilter: _propTypes["default"].bool,
  // Boolean used to keep selected filters persistent, even if data changes. Mainly used in OSA Workqueue
  keepSelectedFilters: _propTypes["default"].bool,
  // Boolean used to turn off show columns menu, default is false.
  canHideColumns: _propTypes["default"].bool,
  // Boolean used to turn off search bar, default is true.
  canSearch: _propTypes["default"].bool,

  /** Search input will be open as default for the Table */
  searchOpen: _propTypes["default"].bool,

  /** Search input custom placeholder for the Table */
  searchPlaceholder: _propTypes["default"].string,

  /** Used by Google Analytics to see where search being used */
  onSearchFocus: _propTypes["default"].func,
  // props from TableContainer
  loading: _propTypes["default"].bool.isRequired,
  tableActions: _propTypes["default"].shape({
    getFormattedRowData: _propTypes["default"].func.isRequired,
    selectAllRowsHandle: _propTypes["default"].func.isRequired,
    updateTableState: _propTypes["default"].func.isRequired,
    getVisibleColumns: _propTypes["default"].func.isRequired
  }),
  tableData: _propTypes["default"].shape({
    bulkActions: _propTypes["default"].array.isRequired,
    bulkStatusChange: _propTypes["default"].bool.isRequired,
    columns: _propTypes["default"].array.isRequired,
    idKey: _propTypes["default"].string.isRequired,
    rowData: _propTypes["default"].array.isRequired,
    selectEnabled: _propTypes["default"].bool.isRequired,
    statusOptions: _propTypes["default"].array,
    title: _propTypes["default"].string,
    tableSettings: _propTypes["default"].shape({
      pageIndex: _propTypes["default"].number.isRequired,
      rowsPerPage: _propTypes["default"].number.isRequired,
      searchTerm: _propTypes["default"].string.isRequired,
      selectedRows: _propTypes["default"].array.isRequired,
      selectedFilters: _propTypes["default"].object.isRequired
    }).isRequired
  })
});

TableToolbar.defaultProps = {
  bulkActions: [],
  bulkStatusChange: false,
  canHideColumns: false,
  canFilter: false,
  keepSelectedFilters: false,
  canSearch: true,
  loading: true
};

var _default = (0, _styles.withStyles)(styles)(TableToolbar);

exports["default"] = _default;